import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { NavBarFilter } from "@abaco/web-common/src/app/Application";
import { Dashboard, DashboardMetadata } from './models/Dashboard';

export default class DashboardVuexModule extends AbacoVuexModule {
    @State({ default: []}) navbarFilters!: NavBarFilter[];
    @State() curDashboard!: Dashboard | null;
    @State({default: []}) pinnedDashboards!: DashboardMetadata[];
    @State() canCreatePublicDash!: boolean;
    @State() isReadOnly!: boolean;
    @State() curHighlightedId!: string;
    @State() viewableTags!: string[];
    @State() creatableTags!: string[];
    @State({default: true}) localFirstLogin!: boolean;
    @State({default: false}) hidePinButton!: boolean;

    @State({default: 0}) showPinButtonRemoveModal!: number;
    @State({default: null}) pinButtonDashbordTileIdentifier!: string | null;
}
